import { AppProviders, LibraryProviders } from "web/Providers"
import { BrowserRouter as Router } from "react-router-dom"
import { Controller } from "@hotwired/stimulus"
import { ModalContainer } from "web/components"
import { render, unmountComponentAtNode } from "react-dom"
import { TLOContextProvider } from "web/contexts"
import { useDeal } from "web/hooks/data"
import ActionPanel from "web/app/Deals/ViewDeal/ActionPanel/ActionPanel"
import React, { Suspense } from "react"

export default class ActionPanelController extends Controller {
  static values = {
    dealId: Number,
  }

  initialize() {
    global.React = React
  }

  connect() {
    const DealTLOContextProvider = ({ children }) => {
      const deal = useDeal(this.dealIdValue)

      return (
        <TLOContextProvider subjectType="deal" data={deal}>
          {children}
        </TLOContextProvider>
      )
    }

    render(
      <Suspense fallback={null}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <DealTLOContextProvider>
                <ActionPanel />
              </DealTLOContextProvider>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }

  disconnect() {
    unmountComponentAtNode(this.element)
  }
}
